import React from "react";
import { RouteObject } from "react-router-dom";
import routePaths from "./../../constants/routes";
import ProtectedRoutes from "utils/ProtectedRoutes";
import Loader from "components/UI/Loader";

const Settings = React.lazy(() => import("./../../pages/Settings"));

export const settingsRoutes: RouteObject[] = [
	{
		path: routePaths.SETTINGS.__PATH,
		element: (
			<ProtectedRoutes>
				<React.Suspense fallback={<Loader />}>
					<Settings />
				</React.Suspense>
			</ProtectedRoutes>
		),
	},
];
